module.exports = __webpack_public_path__ + "img/icon-percent.78cc45aa.svg";